var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaceholderFunction = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M12.598 12 8.04 7.588a.55.55 0 0 1-.164-.386V6.9q0-.225.151-.374a.5.5 0 0 1 .376-.151h6.93q.33 0 .562.232a.77.77 0 0 1 .231.562q0 .331-.231.565a.76.76 0 0 1-.562.235h-4.878l3.623 3.545a.65.65 0 0 1 .207.485.66.66 0 0 1-.207.487l-3.623 3.553h4.878q.33 0 .562.231a.77.77 0 0 1 .231.563q0 .33-.231.561a.77.77 0 0 1-.562.231h-7.08a.36.36 0 0 1-.266-.11.36.36 0 0 1-.111-.268v-.513a.36.36 0 0 1 .118-.28L12.6 12Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceholderFunction);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/placeholder-function.647b770d.svg";